import { Injectable } from '@angular/core';

import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
  HttpResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry, map, tap, last } from 'rxjs/operators';
@Injectable({
  providedIn: 'root',
})
export class CorporateService {

    constructor(private httpClient: HttpClient) {}

    private API_URL = 'services/v1.0/';

    demoRequestCallback(data: string): Observable<HttpResponse<{}>> {
        var url = this.API_URL;
        return this.httpClient
          .post<{}>(
            url + 'demoRequestCallBack',
            { data: data },
            { observe: 'response' }
          )
          .pipe(
            map((res) => {
              if (res && res.body) {
              }
              return res;
            }),
            retry(0),
            catchError(this.handleError)
          );
      }
      private handleError(error: HttpErrorResponse) {
        let errorMessage = 'Unknown error!';
        if (error.error instanceof ErrorEvent) {
          // Client-side errors
          errorMessage = `Error: ${error.error.message}`;
        } else {
          // Server-side errors
          errorMessage = `${error.error.msg}`;
        }
        // window.alert(errorMessage);
        return throwError(errorMessage);
      }
}